import { Component, Input, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonsComponent } from '@enginuity/core/molecules/buttons/buttons.component';
import { SecondaryBtnsComponent } from '@enginuity/core/molecules/secondary-btns/secondary-btns.component';
import { CeIconComponent } from '@enginuity/core/atoms/ce-icon/ce-icon.component';
import { ToastService } from '@services/ui-services/toast.service';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  imports: [CommonModule, ButtonsComponent, SecondaryBtnsComponent, CeIconComponent],
})
export class ToastComponent {
  constructor(private cdr: ChangeDetectorRef) {}

  @Input()
  name = 'Jessica Garry';

  @Input()
  message = 'wants to buy the product';

  @Input()
  info = 'The Product Name';

  @Input()
  time = '2 days ago';

  @Input()
  State: 'accept' | 'accept-loading' | 'default' | 'dismiss' | 'dismiss-loading' = 'accept';

  @Input()
  type: 'avatar' | 'success' | 'cancel' = 'avatar';

  @Input() showControls = true;

  @Input() primaryButton: boolean | { label: string; action: () => void } = false;

  @Input() secondaryButton = false;

  @Input()
  toastIcons = {
    success: 'check',
    cancel: 'cancel',
    avatar: 'type',
  };

  @Input() showCloseButton = true;

  @Input() componentId?: string;

  @Input() toastService?: ToastService;

  @Input() toastId?: string | number;

  dismiss() {
    console.log('ToastComponent.dismiss called', {
      componentId: this.componentId,
      toastId: this.toastId,
      toastService: !!this.toastService,
    });
    if (this.componentId && this.toastService) {
      this.toastService.dismissToastByComponentId(this.componentId);
      return;
    }
    if (this.toastId && this.toastService) {
      this.toastService.dismissToast({ id: this.toastId });
      return;
    } else {
      if (this.toastService) {
        this.toastService.dismissAll();
      }
    }
    this.cdr.markForCheck();
  }

  handlePrimaryButtonClick() {
    if (typeof this.primaryButton === 'object' && this.primaryButton.action) {
      this.primaryButton.action();
    }
  }

  handleSecondaryButtonClick() {
    this.dismiss();
  }
}
